import { useProfile } from "../const/syfApiQueries";
var useUserEmail = function (accountId) {
    var _a = useProfile(accountId), userProfileInfo = _a.data, isLoading = _a.isLoading, isError = _a.isError;
    var userEmail = userProfileInfo === null || userProfileInfo === void 0 ? void 0 : userProfileInfo.profile["cipher.email"];
    return {
        userEmail: userEmail,
        enablePaperlessEnroll: !isLoading && !isError && userEmail,
        showMissingEmailMessage: !isLoading && !isError && !userEmail,
    };
};
export default useUserEmail;
